import Arrow from "../../assets/icons/Arrow";
import CheckMarkIcon from "../../assets/icons/CheckMarkIcon";
import styles from "./styles.module.css";

export interface StepperProps {
  label: string;
  steps: string[];
  currentStepIndex: number;
}
const Stepper: React.FC<Partial<StepperProps>> = ({
  label,
  steps,
  currentStepIndex = 0,
}) => {
  const returnStyles = (index: number): Record<string, React.CSSProperties> => {
    const isCurrent = index === currentStepIndex;
    const isPast = index < currentStepIndex;
    return {
      stepperCircle: {
        background: isCurrent ? "#181717" : isPast ? "#66CC15" : "#FCF7F7",
        color: isCurrent ? "#fff" : isPast ? "" : "#000",
        border: `1px solid ${
          isCurrent ? "#181717" : isPast ? "#66CC15" : "#CAC2C3"
        }`,
        width: "30px",
        aspectRatio: "1/1",
      },
    };
  };

  if (!steps?.length)
    return (
      <span>Enter values for label, steps and currentStepIndex props</span>
    );
  return (
    <div className="d-flex flex-column align-items-end gap-2 px-2 my-2">
      <span className={styles.accountType}>{label}</span>
      <div className="d-flex gap-lg-3 gap-2 w-lg-auto w-100 justify-content-lg-end text-nowrap overflow-x-auto ms-auto">
        {steps.map((step, index) => (
          <div
            key={step}
            className="d-flex gap-2 align-items-center position-relative justify-content-end"
          >
            <span
              style={returnStyles(index).stepperCircle}
              className={`rounded-circle d-flex align-items-center justify-content-center`}
            >
              {currentStepIndex > index ? (
                <CheckMarkIcon className={styles.checkMarkIcon} />
              ) : (
                index + 1
              )}
            </span>
            <span className={styles.stepLabel}>{step}</span>
            {steps.length - 1 > index && <Arrow />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
